import React, { useState } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import HeaderLink from '@Components/Header/HeaderLink';
import HamburgerMenu from '@Components/Header/HamburgerMenu';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const SiteSelector = loadable(() => import('@Components/Header/SiteSelector'));

const HeaderSimpleView = (props) => {

    const currentUser = useRecoilValue(atoms.currentUser);
    const windowSize = useWindowSize();
    const [searchText, setSearchText] = useState('');
    const handleTextChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleEnterKeySubmit = (e) => {
        if (e.keyCode == 13) {
            handleSearch(e);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        var url = searchText ? (props.KeywordSearchUrl + searchText) : props.ViewAllUrl;
        window.location.href = url;
    };

    const headerLinks = props.Links.filter(lnk => lnk.Groups.includes('AircraftLinks') && lnk.ShowOnDesktop);

    const additionalLinks = props.Links.filter(lnk => lnk.Key.includes('lnkLangSelector') && lnk.ShowOnDesktop);

    return (
        <>
            {props.LocalhostSites && <SiteSelector {...props} />}
            <div className='header-wrapper'>
                <div className='header'>
                    <div className='container'>
                        <div className='logo'>
                            <a href={props.HomeUrl}>
                                <img alt={props.LogoImageAltText} src={props.LogoUrl} />
                            </a>
                        </div>
                        {windowSize.isMobile && <HamburgerMenu {...props} />}
                        <div className='search'>
                            <div className='desktop-header-links-container'>
                                {headerLinks && headerLinks.length > 0 &&
                                    <ul className='desktop-header-links'>
                                        {additionalLinks.filter(lnk => lnk.Key == 'lnkLangSelector').map(lnk => <li key={lnk.Key + '_li'}><HeaderLink key={lnk.Key} {...lnk} /></li>)}
                                        {headerLinks.filter(lnk => lnk.Groups.includes('AircraftLinks') && lnk.ShowOnDesktop).map(lnk => <li key={lnk.Key + '_li'}><HeaderLink key={lnk.Key} {...lnk} /></li>)}
                                    </ul>}
                                <div className='auth-container mobile-hide'>
                                    <div className={currentUser.IsAuthenticated ? 'logged-in' : 'logged-out'}>
                                        {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop).map(lnk =>
                                            <HeaderLink key={lnk.Key} {...lnk} />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='search-container'>
                                <label className='visually-hidden' htmlFor='search-container__text-input'>Quick Search</label>
                                <input id='search-container__text-input' type='text' className='search-container__text-input' placeholder={props.SearchPlaceHolderText} onChange={handleTextChange} onKeyDown={handleEnterKeySubmit} />
                                <button title='Search' className='search-container__search-button ts-button' type='submit' onClick={handleSearch}>
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeaderSimpleView;
global.HeaderSimpleView = HeaderSimpleView;